/* eslint-disable import/no-cycle */
import { get } from "lodash";
import ForceLogout from "../../api/ForceLogout";

export const defaultErrorMessage = "Please try again";

// const logoutHandler = async () => {
//   const loginId = localStorage.getItem("loginId");

//   if (loginId) {
//     try {
//       // 👇 Call logout API before clearing memory
//       await ForceLogout.userLogout(loginId);
//     } catch (err) {
//       console.log("Logout API error:", err);
//     }
//   }
//   localStorage.removeItem("authToken");
//   localStorage.removeItem("loginId");
//   window.location.replace("/");
// };

const logoutHandler = async () => {
  const loginId = localStorage.getItem("loginId");

  if (loginId) {
    try {
      console.log("📡 Calling backend logout API...");

      const response = await ForceLogout.userLogout(loginId);

      console.log("🟢 API Response:", response);

      // API success check
      if (response?.status === 200 || response?.data?.code === 200) {
        console.log("🟢 Backend logout status updated successfully");
      } else {
        console.warn("⚠️ Logout API returned unexpected response:", response);
      }
    } catch (err) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("loginId");
      localStorage.removeItem("rolePopupShown");

      window.location.replace("/");
      console.error("🔥 Logout API error:", err);
      // ❌ Mat logout karo agar backend update fail ho jaye
      return;
    }
  }

  // ✔️ API success ke baad hi local logout chalayega
  localStorage.removeItem("authToken");
  localStorage.removeItem("loginId");
  localStorage.removeItem("rolePopupShown");

  window.location.replace("/");
};

function handleErrors(error) {
  const message =
    error?.response?.data?.message || error?.response?.data?.error || "";
  const data = null;

  if (error.response.status === 403) {
    logoutHandler();
  }
  const status = get(error, "status", get(error, "response.status", 701));
  const errorObject = { message, data, status };
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.log("response::error ->", errorObject);
  }
  return Promise.reject(errorObject);
}

export default handleErrors;
